import React, { Component } from 'react'
import Icon from 'components/icon/icon'

export default class SearchMini extends Component {
	state = {
		searchDisplayTerm: '' // we essentially wanna debounce searches so they're not so expensive.
	}

	handleChange = e => {
		const value = e.target.value

		this.setState({
		  searchDisplayTerm: value
		})
	
		clearTimeout(this.searchChangeDebouncer)
	
		this.searchChangeDebouncer = setTimeout(_ => {
			this.props.onSearchTermChange(value)
		},500)
	}

	render() {
		const {
			onSearchTermChange
		} = this.props

		const {
			searchDisplayTerm
		} = this.state

		return (
			<form className="search-mini">
				<input 
					type="text" 
					value={searchDisplayTerm} 
					onChange={this.handleChange} 
					onKeyPress={e => {(e.key === 'Enter') ? (e.preventDefault()) : null }}
					className="search"
				/>
				<Icon name={'fe-search'} />
			</form>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/search-mini/search-mini.jsx